/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/AgenticServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/AgenticPromptMgmtConstants';
import utils from '../../../../common/utils';
import { getPromptV2Client } from '../../../studio/services/prompt/promptServiceHelpers';

export default class CreateAgenticPromptService extends BaseService {
  constructor() {
    super(constants.CREATE_AGENTIC_PROMPT, 'CreateAgenticPromptServiceStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { name, description, comments, promptStart, promptEnd, isAgentic = true } = payload;
    const requestBody = {
      name,
      description: description ?? '',
      comments: comments ?? '',
      promptStart: promptStart ?? [{ role: 'system', content: '' }],
      promptEnd: promptEnd ?? [{ role: 'user', content: '' }],
      isAgentic
    };
    const { client, headers: reqHeaders } = await getPromptV2Client(this, headers);
    return client.post('/prompts', requestBody, { headers: reqHeaders });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('agenticPromptModel').handleCreateResponse(response.data);
  }

  handleError(error) {
    Framework.getStoreRegistry()
      .getStore('agenticPromptModel')
      .handleServiceError(error, PROMPT_MANAGEMENT_LANG_KEYS.ERROR_CREATE, constants.CREATE_AGENTIC_PROMPT_ERROR);
  }
}
